var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPinDisabled = function SvgPinDisabled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 90,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#pin_disabled_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#pin_disabled_svg__b)",
    d: "M8 9h3v80H8z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#pin_disabled_svg__c)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    x: 18,
    y: 1,
    fill: "url(#pin_disabled_svg__d)",
    rx: 8.5,
    transform: "rotate(90 18 1)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "pin_disabled_svg__b",
    x1: 9.5,
    x2: 9.5,
    y1: 9,
    y2: 89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pin_disabled_svg__d",
    x1: 18,
    x2: 35,
    y1: 1.5,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7583A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2B303B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#181B25"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "pin_disabled_svg__a",
    width: 5,
    height: 82,
    x: 7,
    y: 8,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_5539_47072",
    stdDeviation: 0.5
  })), /*#__PURE__*/React.createElement("filter", {
    id: "pin_disabled_svg__c",
    width: 19,
    height: 19,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_5539_47072",
    stdDeviation: 0.5
  })))));
};
export default SvgPinDisabled;